export { default as NPagination, paginationProps } from './src/Pagination';
